export default __webpack_public_path__ + "static/media/token-2.da03423b.png";